interface Breadcrumb {
  label: string;
  url: string;
}

// breadcrumb.component.ts
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { AsyncPipe, JsonPipe } from '@angular/common';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './bread-crumbs.component.html',
  styleUrl: './bread-crumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatListModule, RouterModule, MatListModule, AsyncPipe,JsonPipe],
  standalone: true,
})
export class BreadCrumbsComponent implements OnInit {
  breadcrumbs$?: Observable<Breadcrumb[]>;

  constructor(private breadcrumbService: BreadcrumbService) {}

  ngOnInit(): void {
    this.breadcrumbs$ = this.breadcrumbService.getBreadcrumbs()
  }
}
